import { render, staticRenderFns } from "./UserComponent.vue?vue&type=template&id=66d937e1&scoped=true&"
import script from "./UserComponent.vue?vue&type=script&lang=js&"
export * from "./UserComponent.vue?vue&type=script&lang=js&"
import style0 from "./UserComponent.vue?vue&type=style&index=0&id=66d937e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d937e1",
  null
  
)

export default component.exports